import { convertUTCToDateBarFormat } from 'utils/utils';

export const elementId = 'imageContainer';

const getTime = (date: string, timezone: string) => convertUTCToDateBarFormat(date, timezone).time;

export const date = (startDate: string, timezone: string) => convertUTCToDateBarFormat(startDate, timezone).date;

export const time = (startDate: string, endDate: string, timezone: string) =>
	getTime(startDate, timezone) + ' - ' + getTime(endDate, timezone);
